import React, { useState } from 'react';
import { Input } from "antd";

interface EmailInputProps {
  value?: string;
  onChange?: (value: string, isValid: boolean) => void;
}

export const EmailInput: React.FC<EmailInputProps> = ({ value = "", onChange }) => {
  const [email, setEmail] = useState(value);
  const [error, setError] = useState<string>("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validate = (val: string) => {
    if (!val) {
      setError("Введите email");
      return false;
    }
    if (!emailRegex.test(val)) {
      setError("Некорректный email");
      return false;
    }
    setError("");
    return true;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setEmail(val);
    const isValid = validate(val);
    onChange?.(val, isValid);
  };

  return (
    <div style={{width:'100%'}}>
      <Input
        value={email}
        onChange={handleChange}
        onBlur={() => validate(email)}
        placeholder="ovi@mail.ru"
        status={error ? "error" : ""}
      />
      {error && (
        <div style={{ color: "#ff4d4f", marginTop: 4, fontSize: 12 }}>
          {error}
        </div>
      )}
    </div>
  );
};